import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "@/components/ui/UIElements/Modal";
import { Icon } from "@/components/ui";
import { Button } from "@/components/ui/UIElements/Button";

/**
 * WhatsAppDisconnectModal - Confirmation modal for disconnecting WhatsApp OAuth
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether modal is open
 * @param {Function} props.onClose - Callback when modal is closed
 * @param {Function} props.onConfirm - Callback when disconnect is confirmed
 * @param {boolean} props.isLoading - Whether disconnect action is in progress
 */
const WhatsAppDisconnectModal = ({ isOpen, onClose, onConfirm, isLoading }) => {
  const { t } = useTranslation("aiAgents");

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t("whatsappOAuth.disconnectModal.title")}
      maxWidth="max-w-md"
    >
      <div className="ordering-ai-agent-modal-content space-y-4">
        {/* Warning Box */}
        <div className="border-warning rounded-lg border bg-[var(--warning-bg)] p-4">
          <div className="flex items-start gap-3">
            <Icon
              name="AlertTriangle"
              className="text-warning mt-0.5 h-5 w-5 flex-shrink-0"
            />
            <p className="text-warning text-sm">
              {t("whatsappOAuth.disconnectModal.message")}
            </p>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end gap-3 pt-2">
          <Button
            type="button"
            emphasis="outline"
            intent="neutral"
            size="touch"
            onClick={onClose}
            disabled={isLoading}
          >
            {t("whatsappOAuth.disconnectModal.cancel")}
          </Button>
          <Button
            type="button"
            emphasis="solid"
            intent="danger"
            size="touch"
            busy={isLoading}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {!isLoading && <Icon name="Unlink" />}
            {isLoading
              ? `${t("whatsappOAuth.disconnectModal.confirm")}...`
              : t("whatsappOAuth.disconnectModal.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default WhatsAppDisconnectModal;
